import consumer from "./consumer";

consumer.subscriptions.create("DashboardChannel", {
  received(data) {
    if (data.type == 'entity_card') {
      const dashboardContainer = document.getElementById("dashboard-container");
      if (dashboardContainer) {

        // check if entity card already exists
        const existingCard = document.getElementById(`entity-${data.entity_id}-card`);
        if (existingCard) {
          // If it exists, remove its parent node
          existingCard.parentNode.remove();
        }
        // Insert the HTML content
        dashboardContainer.insertAdjacentHTML("beforeend", data.entity_card_html);

        // Get the newly added card element (last child of dashboard)
        const newCard = dashboardContainer.lastElementChild;

        // Add animation classes
        newCard.style.opacity = '0';
        newCard.style.transform = 'translateY(20px)';
        newCard.style.transition = 'opacity 0.5s ease, transform 0.5s ease';

        // Force reflow to ensure the initial styles are applied
        void newCard.offsetWidth;

        // Trigger animation
        setTimeout(() => {
          newCard.style.opacity = '1';
          newCard.style.transform = 'translateY(0)';
        }, 10);

        let graphContainer = document.getElementById(`entity-${data.entity_id}-graph`);
        const graphDataString = graphContainer.getAttribute('data-config');
        const graphData = JSON.parse(graphDataString);
        
        let graphRenderer = new GraphRenderer(graphContainer, graphData);
        graphRenderer.render();
      }
    } else if (data.type == 'no_connections') {
      hideDashboardSpinner();
    
      const dashboardContainer = document.getElementById("dashboard-container");
      if (dashboardContainer) {
        dashboardContainer.insertAdjacentHTML("beforeend", 
          `<div class="mt-3 mb-3">
            No high risk connections found for the latest report entities
          </div>`
        );
      }
      enableFilters();
    
    } else if (data.type == 'connections_sent') {
      hideDashboardSpinner();
      enableFilters();
    } else if (data.type == 'search_cancelled') {
      hideDashboardSpinner();
    
      const dashboardContainer = document.getElementById("dashboard-container");
      if (dashboardContainer) {
        dashboardContainer.insertAdjacentHTML("beforeend", 
          `<div class="mt-3 mb-3">
            Search was cancelled
          </div>`
        );
      }
      enableFilters();
    }
  }
});

function hideDashboardSpinner() {
  const dashboardSpinner = document.getElementById("dashboard-spinner");
  if (dashboardSpinner) {
    const parentRow = dashboardSpinner.closest("div.row");
    if (parentRow) {
      parentRow.classList.add("d-none");
    }
  }
}

function enableFilters() {
  const filters = document.querySelectorAll(".form-control.search-filter");
  filters.forEach(filter => {
    filter.removeAttribute("disabled");
  });
}